import { REQUEST, RECEIVE, ADDREQUEST, ADD } from '../types/events'


const initialState = {
    list: [],
    currentEvents: [],
    availableDates: [],
    isFetching: false,
    isAdding: false,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case RECEIVE:
            if (action.data.availableDates.length === 1) {
                action.data.availableDates = action.currentAvailableDates
            }
            return Object.assign({}, state, {
                list: action.data,
                availableDates: action.data.availableDates,
                isFetching: false,
                isAdding: false
            })
        case REQUEST:
            return Object.assign({}, state, {
                list: [],
                isFetching: true,
                isAdding: false
            })
        case ADDREQUEST:
            return Object.assign({}, state, {
                isAdding: true
        })
        case ADD:
            let currentEvents = action.currentEvents;
            let newEvents = action.data.data;
            action.data.data = [...currentEvents, ...newEvents]
            return Object.assign({}, state, {
                list: action.data,
                isFetching: false,
                isAdding: false
            })
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/events.js